<template>
  <a-card :bordered="false">
    <!-- 検索区域-begin -->
    <search-area
      ref="SearchArea"
      :rowKeySize="this.selectedRowKeys.length"
      batchType="0"
      parent="TaskManage"
      @searchQuery="searchQuery(false, false)"
      @updateQueryParam="updateQueryParam"
      @batchAction="batchAction"
    ></search-area>
    <!-- 検索区域-end -->

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info div-selected-info">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        {{ this.$t('disp.selected') }}
        <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
        {{ this.$t('disp.item') }}
        <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
      </div> -->

      <a-table
        ref="table"
        class="action"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        @change="handleTableChange"
        tableLayout="auto"
      >
        <!-- 申請時間 -->
        <div slot="startDate" slot-scope="text, record">
          <span>
            {{ moment(record.startDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.startDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <!-- 最近更新時間 -->
        <div slot="endDate" slot-scope="text, record">
          <span>
            {{ moment(record.endDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.endDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <!-- 当前任务 -->
        <div slot="taskName" slot-scope="text, record" style="white-space: nowrap">
          {{ record.name.replaceAll(' ', '') }}
        </div>

        <!-- ステータス -->
        <div slot="taskStatus" slot-scope="text, record">
          <a-tag color="purple" v-if="record.taskStatus == 'disp.flow.applyWait'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag color="orange" v-else-if="record.taskStatus == 'disp.flow.approveWait'">{{
            $t(record.taskStatus)
          }}</a-tag>
          <a-tag color="cyan" v-else-if="record.taskStatus == 'disp.flow.keep'">{{ $t(record.taskStatus) }}</a-tag>
        </div>

        <!-- 処理者 -->
        <div slot="candidate" slot-scope="text, record" class="show-title">
          <TaskColumn :record="record" colType="candidate" :key="refresh"></TaskColumn>
        </div>

        <div slot="action" slot-scope="text, record" style="width: 100%; text-align: left">
          <div v-if="record.keepFlag">
            <!-- 保留取消：保留を行った人は案件を保留状態をなくすことです。 -->
            <a-popconfirm :title="$t('msg.flow.confirm.keepCancel')" @confirm="() => handleCancelKeep(record.id)">
              <a>{{ $t('disp.flow.keepCancel') }}</a>
            </a-popconfirm>
            <!-- 履歴 -->
            <a-divider type="vertical" />
            <a @click="handleHistory(record.processInstanceId, record.processDefinitionName)">{{
              $t('disp.flow.history')
            }}</a>
          </div>

          <div v-else>
            <!-- 处理 -->
            <a @click="handleOpen(record)">{{ $t('disp.flow.operate') }}</a>

            <!-- 委派 -->
            <template v-if="record.taskStatus == 'disp.flow.approveWait'">
              <a-divider type="vertical" />
              <a @click="handleAppoint(record)">委派</a>
            </template>

            <!-- 保留 -->
            <template
              v-if="record.parallelFlag == false && record.paralleltask == false && record.candidateUsers.length > 1"
            >
              <a-divider type="vertical" />
              <a-popconfirm :title="$t('msg.flow.confirm.keep')" @confirm="() => handleKeep(record.id)">
                <a>{{ $t('disp.flow.keep') }}</a>
              </a-popconfirm>
            </template>

            <!-- 取消 -->
            <template v-if="record.cancelFlag">
              <a-divider type="vertical" />
              <a-popconfirm
                :title="$t('msg.flow.confirm.cancel')"
                @confirm="() => handleCancel(record.processInstanceId, record.id)"
              >
                <a>{{ $t('disp.flow.cancel') }}</a>
              </a-popconfirm>
            </template>

            <!-- 履历 -->
            <a-divider type="vertical" />
            <a @click="handleHistory(record.processInstanceId, record.applyName)">{{ $t('disp.flow.history') }}</a>
          </div>
        </div>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 履歴 -->
    <track-modal ref="TrackModal"></track-modal>

    <!-- 申請モーダル：申請フォームを載せる -->
    <apply-modal
      ref="ApplyModal"
      @searchQuery="
        () => {
          searchQuery(true, false)
          $refs.SearchArea.getWfTypeCount()
        }
      "
    ></apply-modal>

    <!-- コメントモーダル：コメントフォームを載せる -->
    <CommentModal ref="CommentModal" @ok="searchQuery(true, false)"></CommentModal>

    <AppointModal ref="AppointModal" @emit="searchQuery(true, false)"></AppointModal>
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { flowMixin } from '@/mixins/flowMixin'
import { putAction, postAction, getAction } from '@/api/manage'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import SearchArea from './modules/SearchArea'
import TrackModal from './modules/TrackModal'
import CommentModal from './modules/CommentModal'
import AppointModal from '@/views/k00/k0011/modules/AppointModal'
import TaskColumn from '@/views/k00/k0011/modules/TaskColumn'

export default {
  name: 'TaskManage',
  mixins: [tableMixin, flowMixin],
  components: {
    JDictSelectTag,
    SearchArea,
    TrackModal,
    CommentModal,
    AppointModal,
    TaskColumn,
  },
  data() {
    return {
      description: '未処理一覧',
      // ログインユーザ情報
      loginUser: this.$store.getters.userInfo,
      showLoadingBySearch: true,
      disableMixinSearchQuery: true,
      refresh: Date.parse(new Date()),
      // テーブルタイトル
      columns: [
        {
          title: this.$t('disp.flow.applyId'),
          //align: 'center',
          //width: 91,
          dataIndex: 'processInstanceId',
          //fixed: 'left',
          customRender: this.renderProcessInstanceId,
        },
        {
          title: this.renderApplyNameHeader,
          dataIndex: 'applyName',
          customRender: this.renderApplyName,
        },
        {
          title: this.$t('disp.flow.starter'),
          align: 'center',
          width: 91,
          customRender: this.renderStarter,
        },
        {
          title: this.$t('disp.flow.starterOrg'),
          align: 'left',
          // width: 180,
          dataIndex: 'starterDepartName',
          customRender: this.renderDepartName,
        },
        {
          title: this.$t('disp.flow.startDate'),
          align: 'left',
          dataIndex: 'startDate',
          //scopedSlots: { customRender: 'startDate' },
          customRender: this.renderDate,
        },
        {
          title: this.$t('disp.flow.lastUpdateDate'),
          align: 'left',
          dataIndex: 'endDate',
          //scopedSlots: { customRender: 'endDate' },
          customRender: this.renderDate,
        },
        // {
        //   title: this.$t('disp.flow.taskId'),
        //   align: 'center',
        //   dataIndex: 'id'
        // },
        {
          title: this.$t('disp.flow.task'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'taskName' },
        },
        {
          title: this.$t('disp.flow.candidate'),
          align: 'center',
          width: 91,
          //fixed: 'right',
          scopedSlots: { customRender: 'candidate' },
        },
        {
          title: this.$t('disp.status'),
          align: 'center',
          width: 91,
          //fixed: 'right',
          scopedSlots: { customRender: 'taskStatus' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          //width: 150,
          //fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/flow/task/list',
        confirm: '/flow/task/confirm',
        refuse: '/flow/task/refuse',
        turnback: '/flow/task/turnback',
        keep: '/flow/task/keep',
        cancelkeep: '/flow/task/cancelkeep',
        cancel: '/flow/task/cancel',
      },
    }
  },
  watch: {
    '$route.params.name': {
      handler(newVal, oldVal) {
        if (this.$refs.SearchArea) {
          if (newVal) {
            this.$refs.SearchArea.$set(this.$refs.SearchArea.queryParam, 'processDefinitionName', newVal)
            this.queryParam.processDefinitionName = newVal
            //this.queryParam.modelId = this.$route.params.modelId
            this.searchQuery(false, false)

            // queryParamをクリアする
            this.$router.push({
              path: this.$route.path,
              query: Object.assign({}, this.$route.query, { _: +new Date() }),
            })
          }
          //else if (this.$route.path == '/blaze-sys/k00/k0011/TaskManage') {
          //  this.searchQuery(false, false)
          //}
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    let name = this.$route.params.name
    if (name) {
      this.$refs.SearchArea.$set(this.$refs.SearchArea.queryParam, 'processDefinitionName', name)
      this.queryParam.processDefinitionName = name
      //this.queryParam.modelId = this.$route.params.modelId
      this.searchQuery(false, false)

      // queryParamをクリアする
      this.$router.push({
        path: this.$route.path,
        query: Object.assign({}, this.$route.query, { _: +new Date() }),
      })
    } else {
      this.searchQuery(false, false)
    }
  },
  methods: {
    updateQueryParam() {
      this.queryParam = this.$refs.SearchArea ? this.$refs.SearchArea.queryParam : {}
    },
    tagColor(user) {
      if (user.taskActive) {
        return 'blue'
      } else {
        return 'blue'
      }
    },
    tagName(user) {
      return user.realname
    },
    handleKeep(id) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.keep, { id: id })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleCancelKeep(id) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.cancelkeep, { id: id })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleCancel(processInstanceId, id) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.cancel, { processInstanceId: processInstanceId, id: id })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleHistory(processInstanceId, title) {
      this.$refs.TrackModal.open(processInstanceId, title)
    },
    handleOpen(record) {
      // 0 下記以外
      // 1 申請ポータル
      // 2 一時保存一覧
      // 3 未処理一覧
      // 4 処理済一覧・進行中案件 or 申請案件一覧・進行中案件
      // 5 処理済一覧・終了案件 or 申請案件一覧・終了案件
      // 6 処理済一覧・非活性案件
      this.$refs.ApplyModal.popupFrom = '3'

      this.$refs.ApplyModal.title = record.applyName
      this.$refs.ApplyModal.component = record.component
      this.$refs.ApplyModal.status = record.taskStatus
      this.$refs.ApplyModal.procInstId = record.processInstanceId
      this.$refs.ApplyModal.executionId = record.executionId
      this.$refs.ApplyModal.taskId = record.id

      this.$refs.ApplyModal.handleOpen()
    },
    handleAppoint(record) {
      this.$refs.AppointModal.handleOpen(record)
    },
    callbackAfterSearchQuery() {
      this.refresh++
    },
  },
}
</script>

<style lang="less" scoped>
</style>
